import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import { faFileAlt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import TabelaQuestao from './TabelaQuestao';
import TabelaCabecalho from './TabelaCabecalho';

export default function ContainerFichaFormularioDeFiscalizacao({ formulario = null }) {
    const [dadosFormulario, setDadosFormulario] = useState(!!formulario ? formulario : {});
    return (
        <div>
            <h5 className="bg-gradient bg-primary rounded-3 text-light p-1"><FontAwesomeIcon icon={faFileAlt} /> Identificação</h5>
            <Row>
                <Col lg="4">
                    <p><span className="fw-bold">Identificação: </span> {dadosFormulario.identificacao}</p>
                </Col>
                <Col lg="4">
                    <p><span className="fw-bold">Entidade Fiscalizada: </span> {dadosFormulario.entidadeFiscalizada}</p>
                </Col>
                <Col lg="8">
                    <p><span className="fw-bold">Ativo? </span> {dadosFormulario.ativo ? "Sim" : "Não"}</p>
                </Col>
            </Row>
            <h5 className="bg-gradient bg-primary rounded-3 text-light p-1"><FontAwesomeIcon icon={faPencilAlt} /> Cabeçalhos</h5>
            <TabelaCabecalho items={dadosFormulario.cabecalhos} ficha />
            <h5 className="bg-gradient bg-primary rounded-3 text-light p-1"><FontAwesomeIcon icon={faPencilAlt} /> Questões</h5>
            <TabelaQuestao items={dadosFormulario.questoes} ficha />
        </div>
    );
}